import MarkdownParser from 'components/rich-text/markdown-parser';
import { Link } from 'src/navigation';
import { routeForDocument } from '@metmuseum/routes';
import styles from './press-card.module.scss';
import {
	formatDate,
	dateFormatFull,
	newYorkizeDate,
	epochTimeToUTCYYYYMMDD,
} from 'helpers/date-time';

const PressCard = ({
	title,
	slug,
	releaseDate,
	updatedDate,
	sanityType,
}: Props) => {
	const link = routeForDocument({ _type: sanityType, slug: { current: slug } });
	const date = updatedDate
		? `Updated on ${formatDate(newYorkizeDate(epochTimeToUTCYYYYMMDD(updatedDate)), dateFormatFull)}`
		: formatDate(
				newYorkizeDate(epochTimeToUTCYYYYMMDD(releaseDate)),
				dateFormatFull,
			);

	return (
		<div className={styles.card}>
			<Link href={link} className={styles.titleLink}>
				<h3>
					<MarkdownParser>{title}</MarkdownParser>
				</h3>
			</Link>
			<span>{date}</span>
		</div>
	);
};

export default PressCard;

export type Props = {
	releaseDate: number; // the EpochTimeStamp type is throwing a linter error. EpochTimeStamp and number are the same
	sanityType: string;
	slug: string;
	title: string;
	updatedDate?: number; // also EpochTimeStamp
};
